/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchGuardianMemoResponseDto } from '../../models/search-guardian-memo-response-dto';

export interface ParentGuardianControllerSearchByParent$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 아동 ID
 */
  childId?: string;
}

export function parentGuardianControllerSearchByParent(http: HttpClient, rootUrl: string, params: ParentGuardianControllerSearchByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchGuardianMemoResponseDto>> {
  const rb = new RequestBuilder(rootUrl, parentGuardianControllerSearchByParent.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchGuardianMemoResponseDto>;
    })
  );
}

parentGuardianControllerSearchByParent.PATH = '/api/guardian/parent';
